import React, { useState, useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const MenuBar = ({ editor }) => {
  if (!editor) return null;
  const buttons = [
    { label: "G",       title: "Gras",           action: () => editor.chain().focus().toggleBold().run(),                  active: editor.isActive("bold"),           style: { fontWeight: "bold" } },
    { label: "I",       title: "Italique",        action: () => editor.chain().focus().toggleItalic().run(),                active: editor.isActive("italic"),         style: { fontStyle: "italic" } },
    { label: "S",       title: "Barré",           action: () => editor.chain().focus().toggleStrike().run(),                active: editor.isActive("strike"),         style: { textDecoration: "line-through" } },
    { label: "U",       title: "Souligné",        action: () => editor.chain().focus().toggleUnderline().run(),             active: editor.isActive("underline"),      style: { textDecoration: "underline" } },
    { label: "H1",      title: "Titre 1",         action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),   active: editor.isActive("heading", { level: 1 }) },
    { label: "H2",      title: "Titre 2",         action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),   active: editor.isActive("heading", { level: 2 }) },
    { label: "• List",  title: "Liste à puces",   action: () => editor.chain().focus().toggleBulletList().run(),            active: editor.isActive("bulletList") },
    { label: "1. List", title: "Liste numérotée", action: () => editor.chain().focus().toggleOrderedList().run(),           active: editor.isActive("orderedList") },
    { label: "❝",       title: "Citation",        action: () => editor.chain().focus().toggleBlockquote().run(),            active: editor.isActive("blockquote") },
    { label: "—",       title: "Séparateur",      action: () => editor.chain().focus().setHorizontalRule().run(),           active: false },
    { label: "↩",       title: "Annuler",         action: () => editor.chain().focus().undo().run(),                       active: false },
    { label: "↪",       title: "Rétablir",        action: () => editor.chain().focus().redo().run(),                       active: false },
  ];
  return (
    <div className="nh-menubar">
      {buttons.map((btn, i) => (
        <button key={i} title={btn.title}
          className={`nh-menubar-btn ${btn.active ? "nh-menubar-btn--active" : ""}`}
          style={btn.style || {}} onClick={btn.action} type="button">
          {btn.label}
        </button>
      ))}
    </div>
  );
};

const ResumeEditor = ({ content, onChange }) => {
  const editor = useEditor({
    extensions: [StarterKit],
    content: content || "",
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (editor && content !== editor.getHTML()) {
      editor.commands.setContent(content || "");
    }
  }, [content]);

  return (
    <div className="nh-editor-wrapper">
      <MenuBar editor={editor} />
      <EditorContent editor={editor} className="nh-editor" />
    </div>
  );
};

const getPaginationItems = (total, current) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i);
  const items = [];
  items.push(0);
  if (current > 3) items.push("...");
  for (let i = Math.max(1, current - 1); i <= Math.min(total - 2, current + 1); i++) {
    items.push(i);
  }
  if (current < total - 4) items.push("...");
  items.push(total - 1);
  return items;
};

const TabPages = ({ pages, activePage, setActivePage, onChangePage, onAddPage, onDeletePage }) => {




  const page = pages[activePage] || {};

  return (
    <div className="nh-tabpages">

      {/* ── Pagination ── */}
    <div className="nh-pages-nav">
        <div className="nh-pages-tabs">
            <button className="nh-nav-page-btn" onClick={() => setActivePage((p) => Math.max(0, p - 1))} disabled={activePage === 0}>‹</button>
            {getPaginationItems(pages.length, activePage).map((item, i) =>
            item === "..." ? (
                <span key={i} className="nh-ellipsis">…</span>
            ) : (
                <button key={i}
                className={`nh-page-tab ${activePage === item ? "nh-page-tab--active" : ""}`}
                onClick={() => setActivePage(item)}>
                {item + 1}
                </button>
            )
            )}
            <button className="nh-nav-page-btn" onClick={() => setActivePage((p) => Math.min(pages.length - 1, p + 1))} disabled={activePage === pages.length - 1}>›</button>
        </div>
        <button className="nh-add-page-btn" onClick={onAddPage}>
            + Ajouter
        </button>
    </div>

      {/* ── Champs ── */}
      <div className="nh-fields">

        <div className="nh-row">
          <div className="nh-field-group">
            <label>Date début</label>
            <input type="date"
              value={page.date_debut ?? ""}
              onChange={(e) => onChangePage(activePage, "date_debut", e.target.value)} />
          </div>
          <div className="nh-field-group">
            <label>Date fin</label>
            <input type="date"
              value={page.date_fin ?? ""}
              onChange={(e) => onChangePage(activePage, "date_fin", e.target.value)} />
          </div>
        </div>

        <div className="nh-field-group">
          <label>Médecin</label>
          <input type="text" placeholder="Nom du médecin..."
            value={page.medecin ?? ""}
            onChange={(e) => onChangePage(activePage, "medecin", e.target.value)} />
        </div>

        <div className="nh-field-group">
          <label>Motif</label>
          <input type="text" placeholder="Motif de l'hospitalisation..."
            value={page.motif ?? ""}
            onChange={(e) => onChangePage(activePage, "motif", e.target.value)} />
        </div>

        <div className="nh-row" style={{ flexWrap: "wrap", gap: "0.75rem", marginBottom: "0.75rem" }}>
            {[
                { key: "poids",  label: "Poids (kg)", type: "number", step: "0.1",  placeholder: "Ex : 47"   },
                { key: "taille", label: "Taille (m)", type: "number", step: "0.01", placeholder: "Ex : 1.64" },
                { key: "pb",     label: "PB (cm)",    type: "number", step: "0.1",  placeholder: "PB"        },
                { key: "pc",     label: "PC (cm)",    type: "number", step: "0.1",  placeholder: "PC"        },
                { key: "pn",     label: "PN (kg)",    type: "number", step: "0.1",  placeholder: "PN"        },
                { key: "zscore", label: "Z-score",    type: "text",   step: null,   placeholder: "Z-score"   },
            ].map(({ key, label, type, step, placeholder }) => (
                <div key={key} className="nh-field-group" style={{ flex: "0 0 150px", width: "150px" }}>
                <label>{label}</label>
                <input
                    type={type}
                    step={step || undefined}
                    placeholder={placeholder}
                    value={page[key] ?? ""}
                    onChange={(e) => onChangePage(activePage, key, e.target.value)} />
                </div>
            ))}
        </div>

        <div className="nh-field-group">
          <label>Résumé</label>
          <ResumeEditor
            key={activePage}
            content={page.resume || ""}
            onChange={(html) => onChangePage(activePage, "resume", html)}
          />
        </div>

        <div className="nh-divider" />

        <div className="nh-row">
          <div className="nh-field-group">
            <label>Date prochain RDV</label>
            <input type="date"
              value={page.date_prochain_rdv ?? ""}
              onChange={(e) => onChangePage(activePage, "date_prochain_rdv", e.target.value)} />
          </div>
          <div className="nh-field-group">
            <label>Motif RDV</label>
            <input type="text" placeholder="Motif du prochain RDV..."
              value={page.motif_rdv ?? ""}
              onChange={(e) => onChangePage(activePage, "motif_rdv", e.target.value)} />
          </div>
        </div>

      </div>

      {/* ── Supprimer ── */}
      {activePage > 0 && (
        <button className="nh-delete-page-btn" onClick={() => onDeletePage(activePage)}>
          🗑 Supprimer cette hospitalisation
        </button>
      )}

    </div>
  );
};

export default TabPages;